import ObjectInputElement from './ObjectInputElement'

export default function EditableField({decorator, setObject, attribute, editing, suggestions}) {
  if (editing) {
    return <ObjectInputElement object={decorator.object} setObject={setObject} attribute={attribute} suggestions={suggestions} />
  }
  return decorator[attribute] || null
}
